import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';
import $ from 'jquery';

export default {
	init() {

		function SliderFullScreen( container ) {

			var slides = container.querySelectorAll('.slider__single');

			var slideTime = 7000; // in milisecond

			var slideCurrent = 0;
			var slideMax = slides.length;

			var firstExecute = true;

			var interval;



			function startLoop() {

				interval = setInterval(
					function() {
						nextSlide();
					},
					slideTime
				);

			}

			function nextSlide() {

				slideCurrent +=1;

				if( slideCurrent >= slideMax ) {

					slideCurrent = 0;

				}

				slides.forEach( function( slide, index ) {

					if( slideCurrent == index ) {

						slide.classList.add('active');

					} else {

						slide.classList.remove('active');

					}

				});

			}

			function prevSlide() {

				slideCurrent -= 1;

				if( slideCurrent < 0 ) {

					slideCurrent = slideMax - 1;

				}

				slides.forEach( function( slide, index ) {

					if( slideCurrent == index ) {

						slide.classList.add('active');

					} else {

						slide.classList.remove('active');

					}

				});

			}

			function endLoop(){

				clearInterval( interval );

			}

			container.classList.add('animation');
			slides[0].classList.add('active');
			slides[0].classList.remove('loaded');
			startLoop();

			// -- ScrollMagic -- // 

				var controller = new ScrollMagic.Controller();

				new ScrollMagic.Scene({triggerElement: container, triggerHook: 0 })
					.on('start', function(){

						if( container.classList.contains('animation') ) {

							container.classList.remove('animation');
							endLoop();

						} else {

							container.classList.add('animation');
							nextSlide();
							startLoop();

						}

					})
					// .addIndicators({name: " - SliderFullScreen"}) // add indicators (requires plugin)
					.addTo( controller )
					.offset( container.offsetHeight );

			// -- END -- / 



			// -- Buttons -- // 

				var buttonPrev = container.querySelector('.slider__button--prev');
				var buttonNext = container.querySelector('.slider__button--next');

				buttonPrev.addEventListener('click', function() {

					endLoop();
					prevSlide();
					startLoop();

				});

				buttonNext.addEventListener('click', function(){

					endLoop();
					nextSlide();
					startLoop();

				});

			// -- END -- //

		}

		function SliderFullScreenScroll( container ) {

			var scroll = container.querySelector('.slider__scroll');

			var nextSection = document.querySelectorAll('section')[1];
			var nextSectionCoordinate = nextSection.getBoundingClientRect().top + window.pageYOffset;

			var header = document.querySelector('header');
			var headerHeight = header.offsetHeight;

			var topMove = nextSectionCoordinate - headerHeight;

			scroll.addEventListener('click', function() {
				
				$('html ,body').animate({'scrollTop': topMove }, 'smooth');

			});

			window.addEventListener('resize', function(){ 

				nextSection = document.querySelectorAll('section')[1];
				nextSectionCoordinate = nextSection.getBoundingClientRect().top + window.pageYOffset;

				header = document.querySelector('header');
				headerHeight = header.offsetHeight;

				topMove = nextSectionCoordinate - headerHeight;

			});

		}

		var container = document.querySelectorAll('.sliderFullScreen');
    	
		if( container.length == 1 ) {

			SliderFullScreen( container[0] );
			SliderFullScreenScroll( container[0] );

		}

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
